import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { CoreApplicationContext } from '@eventbrite/context-gen';
import React from 'react';
import { EnvProvider, LocationProvider } from './context';
import { Routes } from './routes';
import { AppProps } from './types';

export const App: React.FC<AppProps & CoreApplicationContext> = (props) => {
    const FIVE_MINUTES = 5 * 60 * 1000;
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                retry: false,
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                refetchOnMount: false,
                staleTime: FIVE_MINUTES,
            },
        },
    });

    return (
        <QueryClientProvider client={queryClient}>
            <EnvProvider
                env={props.env}
                request={props.request}
                user={props.user}
                app_version={props.app_version}
                app_name={props.app_name}
                isBotRequest={props.isBotRequest}
            >
                <LocationProvider
                    shortPlaceName={props.shortPlaceName}
                    placeName={props.placeName}
                    location_slug={props.location_slug}
                >
                    <Routes {...props} />
                </LocationProvider>
            </EnvProvider>
        </QueryClientProvider>
    );
};
